// Validation for the Counters & Limits numeric inputs.
//
// Historically this rejected any value below `counters[key]` — the error called
// it "current usage". But that counter is a remaining balance that the backend
// resets up to the cap on every change (RisikaAPI refresh_restrictions), so the
// counter was always >= the current cap. That turned every counter into a
// one-way ratchet that could never be lowered through the dashboard (ENG2-2118).
//
// Admins must be able to correct a cap downwards, and lowering is safe: the
// backend re-seeds the counter to the new cap on save, so there is no
// data-integrity risk. We now only reject values that are not a usable
// non-negative number.
export const isValidCounterValue = (value: number): boolean =>
  typeof value === 'number' && !Number.isNaN(value) && value >= 0
